(function () {

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildItem(d, i18n) {
    var bestseller = i18n.bestseller || 'Bestseller';
    var unit = i18n.unit || 'pcs';
    var youSaveTpl = i18n.youSave || 'You save {{ percent }}%';
    var youSave = youSaveTpl.replace('__PCT__', String(d.off));
    var ariaLabel = (d.featured ? bestseller + ', ' : '') +
      d.qty + ' ' + unit + ', ' + (d.label || '') + ', ' + youSave;

    return '' +
      '<button type="button"' +
      ' class="mr3__item ' + (d.featured ? 'mr3__item--featured' : '') + '"' +
      ' data-qty="' + escapeHtml(d.qty) + '"' +
      ' aria-pressed="false"' +
      ' aria-label="' + escapeHtml(ariaLabel) + '">' +
        (d.featured ? '<span class="mr3__badge" aria-hidden="true">' + escapeHtml(bestseller) + '</span>' : '') +
        '<div class="mr3__left" aria-hidden="true">' +
          '<div class="mr3__qty">' + escapeHtml(d.qty) + '<span> ' + escapeHtml(unit) + '</span></div>' +
          '<span class="mr3__pill ' + (d.featured ? 'mr3__pill--blue' : '') + '">' +
            escapeHtml(d.label || '') +
          '</span>' +
        '</div>' +
        '<div class="mr3__right" aria-hidden="true">' +
          '<div class="mr3__off">' + escapeHtml(d.off) + '%</div>' +
          '<div class="mr3__save">' + escapeHtml(youSave) + '</div>' +
        '</div>' +
      '</button>';
  }

  function readI18n(root) {
    return {
      bestseller: root.dataset.i18nBestseller,
      unit: root.dataset.i18nUnit,
      youSave: root.dataset.i18nYouSave,
    };
  }

  function init(root) {
    if (!root) return;

    var dataEl = document.querySelector('[data-mr3-variants]');
    if (!dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var list = root.querySelector('.mr3__list');
    var i18n = readI18n(root);

    var getQtyInput = function () {
      var form = root.closest('form');
      return (form && form.querySelector('input[name="quantity"]')) ||
        document.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
        document.querySelector('.quantity__input');
    };

    var getVariantInput = function () {
      var form = root.closest('form');
      return (form && form.querySelector('input[name="id"]')) ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]');
    };

    var setActive = function (q) {
      var n = Number(q);
      root.querySelectorAll('.mr3__item').forEach(function (btn) {
        var active = Number(btn.dataset.qty) === n;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    root.addEventListener('click', function (e) {
      var item = e.target.closest('.mr3__item');
      if (!item) return;
      var qtyInput = getQtyInput();
      var quantityField = document.querySelector('input[name="quantity"]');
      if (!qtyInput) return;
      qtyInput.value = item.dataset.qty;
      if (quantityField) quantityField.value = item.dataset.qty;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      setActive(item.dataset.qty);
    });

    var variantInput = getVariantInput();
    if (variantInput) {
      var lastVariant = variantInput.value;

      var observer = new MutationObserver(function () {
        if (variantInput.value === lastVariant) return;
        lastVariant = variantInput.value;

        var discounts = variants[lastVariant];
        if (!discounts || !list) {
          root.style.display = 'none';
          return;
        }

        root.style.display = '';
        list.innerHTML = discounts.map(function (d) { return buildItem(d, i18n); }).join('');

        var qtyInput = getQtyInput();
        if (qtyInput && qtyInput.value) {
          setActive(qtyInput.value);
        }
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    var qtyInput = getQtyInput();
    if (qtyInput && qtyInput.value) setActive(qtyInput.value);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mr3]').forEach(init);
  });

})();

(function () {
  var dataEl = document.querySelector('[data-unit-price-variants]');
  if (!dataEl) return;

  var prices = JSON.parse(dataEl.textContent);

  var getVariantInput = function () {
    return document.querySelector('form[action*="/cart/add"] input[name="id"]');
  };

  var container = document.querySelector('[data-unit-price]');
  var valueEl = container && container.querySelector('[data-unit-price-value]');

  if (!container || !valueEl) return;

  var variantInput = getVariantInput();
  if (!variantInput) return;

  var last = variantInput.value;

  var update = function () {
    var vId = variantInput.value;
    if (vId === last) return;
    last = vId;

    var price = prices[vId];
    if (!price) {
      container.style.display = 'none';
      return;
    }

    container.style.display = '';
    valueEl.textContent = price;
  };

  new MutationObserver(update).observe(variantInput, {
    attributes: true,
    attributeFilter: ['value']
  });
})();
